import React from "react";

export default function CormoSchema({
  metaDescription = "Software House Cormo - tworzymy aplikacje webowe i mobilne. Zajmujemy się również UX/UI oraz tworzeniem stron internetowych.",
}) {
  const schemaOrg = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Cormo Software House",
    url: "https://cormo.pl",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+48 789 789 909",
      contactType: "Company",
      email: "kontakt@cormo.pl",
      availableLanguage: ["Polish", "English"],
    },
    alternatName: "Cormo",
    sameAs: ["https://www.facebook.com/cormopl", "https://pl.linkedin.com/company/cormo-software-house"],
    description: metaDescription,
    address: {
      "@type": "PostalAddress",
      streetAddress: "Marka Kotańskiego 8/5",
      addressLocality: "Olsztyn",
      postalCode: "10-166",
      addressCountry: "PL",
    },
    aggregateRating: {
      "@type": "AggregateRating",
      ratingValue: 5,
      ratingCount: 11,
    },
    hoursAvailable: {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "08:00",
      closes: "16:00",
    },
  };

  return <script type="application/ld+json">{JSON.stringify(schemaOrg)}</script>;
}
